import classNames from 'classnames';

import { ComponentClassNames } from '../../shared';
import { View } from '../../View';

export const IconQueuePlayNext = (props) => {
  const { className, ...rest } = props;
  return (
    <View
      as="span"
      width="1em"
      height="1em"
      className={classNames(ComponentClassNames.Icon, className)}
      {...rest}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 3H3C1.89 3 1 3.89 1 5V17C1 18.1 1.89 19 3 19H8V21H16V19H18V17H3V5H21V13H23V5C23 3.89 22.1 3 21 3ZM13 10V7H11V10H8V12H11V15H13V12H16V10H13ZM24 18L19.5 22.5L18 21L21 18L18 15L19.5 13.5L24 18Z"
          fill="currentColor"
        />
      </svg>
    </View>
  );
};
